const sideCartInit = () => {
  const sideCart = document.getElementById('side-cart');
  if (!sideCart) return;

  const body = document.body;
  const countEl = sideCart.querySelector('.side-cart__count');

  const closeTriggers = document.querySelectorAll(
    '.side-cart__overlay, .side-cart__close, .side-cart__continue'
  );

  const openCart = () => {
    sideCart.classList.add('active');
    body.style.overflow = 'hidden';
  };

  const closeCart = () => {
    sideCart.classList.remove('active');
    body.style.overflow = '';
  };

  const updateCount = () => {
    const qty = document.querySelectorAll('.mini_cart_item').length;

    // SIDE CART LABEL
    if (countEl) {
      const t = rcTranslate;
      countEl.textContent =
        qty === 1
          ? t.productSingular.replace('%d', qty)
          : t.productPlural.replace('%d', qty);
    }

    // HEADER BADGE
    document.querySelectorAll('.cart-btn .number').forEach((badge) => {
      if (qty > 0) {
        badge.textContent = qty;
        badge.style.display = '';
      } else {
        badge.textContent = '0';
        badge.style.display = 'none';
      }
    });
  };


  closeTriggers.forEach((btn) => {
    btn.addEventListener('click', closeCart);
  });

  jQuery(document.body).on('added_to_cart', () => {
    openCart();
  });

  jQuery(document.body).on(
    'added_to_cart',
    function (event, fragments, cart_hash, $button) {
      if (!$button || !$button.length) return;

      $button
        .text(rcTranslate.view_in_cart)
        .attr('type', 'button')
        .removeClass('ajax_add_to_cart add_to_cart_button')
        .addClass('secondary-btn btn btn-border btn-black open-side-cart');
    }
  );

  function restoreAddToCartButton(productId) {
    const $btn = jQuery(
      `[data-product_id="${productId}"]`
    );

    if (!$btn.length) return;

    $btn
      .text(rcTranslate.add_to_cart)
      .attr('type', 'submit')
      .removeClass('open-side-cart secondary-btn btn-border btn-black')
      .addClass('single_add_to_cart_button button alt ajax_add_to_cart add_to_cart_button');
  }

  let lastRemovedProductId = null;

  jQuery(document).on(
    'click',
    '.mini_cart_item .remove_from_cart_button',
    function (e) {
      const $btn = jQuery(e.currentTarget);

      lastRemovedProductId = $btn.data('product_id');
    }
  );

  jQuery(document.body).on(
    'removed_from_cart wc_fragments_refreshed',
    function () {
      if (!lastRemovedProductId) return;

      restoreAddToCartButton(lastRemovedProductId);
      lastRemovedProductId = null;
    }
  );

  jQuery(document.body).on(
    'wc_fragments_loaded wc_fragments_refreshed added_to_cart removed_from_cart',
    updateCount
  );

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".open-side-cart");
    if (!trigger) return;
    e.preventDefault()

    openCart();
  });

  updateCount();
};

export default sideCartInit;
